import { LegalPageLayout } from "./LegalPageLayout";

export default function Cookies() {
  return (
    <LegalPageLayout title="Politique de Cookies">
      <h2>1. Qu'est-ce qu'un cookie ?</h2>
      <p>
        Un cookie est un petit fichier texte enregistré sur votre appareil lors de 
        la visite d'un site web. Il permet au site de reconnaître votre navigateur 
        et d'améliorer votre expérience utilisateur.
      </p>

      <h2>2. Cookies utilisés</h2>
      
      <h3>a) Cookies strictement nécessaires</h3>
      <p>Essentiels au bon fonctionnement du site :</p>
      <ul>
        <li><strong>Session d'authentification</strong> : maintient votre connexion</li>
        <li><strong>Sécurité</strong> : protection contre les attaques CSRF</li>
        <li><strong>Préférences</strong> : langue, thème, accessibilité</li>
      </ul>

      <h3>b) Cookies de performance</h3>
      <p>Utilisés pour analyser l'utilisation du site :</p>
      <ul>
        <li>Pages visitées</li>
        <li>Durée de session</li>
        <li>Erreurs techniques</li>
      </ul>
      <p><em>(Ces données sont anonymisées.)</em></p>

      <h3>c) Cookies tiers</h3>
      <p>
        Libaddict n'utilise pas de cookies publicitaires ni de cookies de réseaux sociaux.
      </p>

      <h2>3. Gestion de vos préférences</h2>
      <p>
        Lors de votre première visite, une bannière vous permet d'accepter ou 
        refuser les cookies non essentiels.
      </p>
      <p>
        Vous pouvez également supprimer ou modifier vos préférences à tout moment 
        via les paramètres de votre navigateur.
      </p>

      <h2>4. Contact</h2>
      <p>
        Pour toute question relative à notre politique de cookies :<br />
        📧 <a href="mailto:conception.vpdev@gmail.com">conception.vpdev@gmail.com</a>
      </p>
    </LegalPageLayout>
  );
}
